import type { ReactNode } from 'react';
import type { Problem } from '../api/types';
import { KeyValue } from './KeyValue';

export interface ProblemNoticeProps {
  /** nullなら何も描かないので、呼び出し側で条件分岐を書かずに済む。 */
  problem: Problem | null;
  /**
   * 503（依存停止・配備中）や409（状態競合）は再試行や再読込で解ける状況なので、
   * すべて赤にせずnoticeで出せるようにする。どちらで出すかは画面側の判断。
   */
  tone?: 'error' | 'notice';
  /** 「再試行」「実行履歴へ戻る」など、この失敗に対する操作。 */
  action?: ReactNode;
}

/**
 * application/problem+jsonをそのまま読める形で出す。
 * code / detail / traceId は運用時に原因を特定する唯一の手掛かりなので隠さず全文を出し、
 * errorsも省略せずJSONのまま見せる。
 */
export function ProblemNotice({ problem, tone = 'error', action }: ProblemNoticeProps) {
  if (problem === null) return null;
  return (
    <div
      className={`problem problem-${tone}`}
      role={tone === 'error' ? 'alert' : 'status'}
      data-status={problem.status}
    >
      <div className="problem-head">
        <strong className="problem-title">{problem.title}</strong>
        {action === undefined ? null : <div className="problem-action">{action}</div>}
      </div>
      <p className="problem-detail">{problem.detail}</p>
      <KeyValue
        className="problem-meta"
        items={[
          { label: 'status', value: problem.status },
          { label: 'code', value: problem.code },
          { label: 'traceId', value: problem.traceId },
        ]}
      />
      {problem.errors === undefined || problem.errors.length === 0 ? null : (
        <pre className="problem-errors">{JSON.stringify(problem.errors, null, 2)}</pre>
      )}
    </div>
  );
}
